import { DynamicIcon } from 'lucide-react/dynamic';
import type { CSSProperties } from 'react';
import type { FabrikAppLogo, FabrikLogoIcon, FabrikResolvedAppearance } from '../../types/apps';
import { logoForegroundColor } from './theme';

const presetIconNames = { northstar: 'compass', pulse: 'activity', beacon: 'radio' } as const;

type Props = {
  tenantName: string;
  appearance?: FabrikResolvedAppearance;
  logo?: FabrikAppLogo;
  logoColor?: string;
  className?: string;
  imageClassName?: string;
};

export default function AppBrandMark({
  tenantName,
  appearance,
  logo,
  logoColor,
  className,
  imageClassName,
}: Props) {
  const iconName: FabrikLogoIcon | undefined =
    logo?.type === 'icon'
      ? logo.icon
      : !logo && appearance?.logo?.type === 'icon'
      ? appearance.logo.icon
      : !logo && appearance?.logo?.type === 'preset'
      ? presetIconNames[appearance.logo.preset]
      : undefined;
  const imageUrl =
    logo?.type === 'custom'
      ? appearance?.logo?.type === 'image'
        ? appearance.logo.url
        : undefined
      : !logo && appearance?.logo?.type === 'image'
      ? appearance.logo.url
      : undefined;
  const color = logo?.color || logoColor || appearance?.primaryColor;

  return (
    <span
      className={`app-brand-mark ${className || ''}`}
      data-logo-color={color || undefined}
      data-logo-style={logo?.type === 'typography' ? logo.style || 'default' : undefined}
      style={
        color
          ? ({
              '--logo-color': color,
              '--logo-foreground': logoForegroundColor(color),
            } as CSSProperties)
          : undefined
      }
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt=""
          className={imageClassName || 'h-full w-full rounded-md object-contain'}
        />
      ) : iconName ? (
        <DynamicIcon name={iconName} className="size-1/2" aria-hidden="true" />
      ) : (
        tenantName.trim().charAt(0).toUpperCase() || 'A'
      )}
    </span>
  );
}
